export const initRemoveLineDecor = () => {
  const mainContent = document.getElementById('main-content');

  if (
    (document.querySelector('.white-bg') &&
      document.querySelector('.blog-share-icons')) ||
    document.querySelector('.white-bg')
  ) {
    mainContent.classList.add('remove-line');
  }
};
